import React, { useState } from "react";
import { Link, animateScroll as scroll } from "react-scroll";

export const Footer = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <div className="tw-h-[363px] tw-flex tw-flex-col tw-items-center tw-justify-center">
      <div className="tw-grid tw-grid-cols-2 tw-gap-32 ">
        <div>
          <p className="tw-text-[24px] tw-font-bold tw-text-[#D0E8F4]">
            Paginas
          </p>
          <div className="tw-flex tw-flex-col">
          <Link
              className="tw-text-base tw-text-[#D0E8F4]"
              to="sobre-mim"
              smooth={true}
              duration={500}
              onClick={() => {
                toggleMobileMenu();
                scroll.scrollTo(0, {
                  duration: 500,
                  smooth: "easeInOutQuart",
                });
              }}
            >
              Sobre mim
            </Link>
          <Link
              className="tw-text-base tw-text-[#D0E8F4]"
              to="skills"
              smooth={true}
              duration={500}
              onClick={() => {
                toggleMobileMenu();
                scroll.scrollTo(1000, {
                  duration: 500,
                  smooth: "easeInOutQuart",
                });
              }}
            >
              Skills
            </Link>
            <Link
              className="tw-text-base tw-text-[#D0E8F4]"
              to="projetos"
              smooth={true}
              duration={500}
              onClick={() => {
                toggleMobileMenu();
                scroll.scrollTo(2000, {
                  duration: 500,
                  smooth: "easeInOutQuart",
                });
              }}
            >
              Projetos
            </Link>
            
          </div>
        </div>
        <div>
          <p className="tw-text-[24px] tw-font-bold tw-text-[#D0E8F4]">
            Contato
          </p>
          <div className="tw-flex tw-flex-col">
            <a target="_blank"
              className="tw-text-base tw-text-[#D0E8F4]"
              href="https://github.com/pablokaue2004"
            >
              Github
            </a>
            <a target="_blank"
              className="tw-text-base tw-text-[#D0E8F4]"
              href="https://www.linkedin.com/in/pablo-kau%C3%AA-454180207/"
            >
              Linkedln
            </a>
            <a target="_blank"
              className="tw-text-base tw-text-[#D0E8F4]"
              href="mail:pablokauedev23@gmail.com"
            >
              Gmail
            </a>
          </div>
        </div>
      </div>
      <div className="tw-mt-10">
        <p className="tw-text-base tw-text-[#D0E8F4]">
          Copyright (©) 2023 Pablo Kauê. Todos os direitos reservados.
        </p>
      </div>
    </div>
  );
};
